module.exports = __webpack_public_path__ + "static/media/reddit-square.8ddeb578.svg";